import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/v2/class-operation'

export default {
  namespaced: true,
  state: {
    ...baseState
  },
  mutations: {
    ...baseMutations
  },
  actions: {
    /**
     * Get main programs
     */
    getMainPrograms() {
      return httpClient.get(`${BASE_URL}/main-programs`)
    },

    /**
     * Get sub programs by main program ID
     */
    getSubPrograms(context, mainProgramId) {
      return httpClient.get(`${BASE_URL}/sub-programs`, {
        params: { main_program_id: mainProgramId }
      })
    },

    /**
     * Get grades by sub program ID
     */
    getGrades(context, subProgramId) {
      return httpClient.get(`${BASE_URL}/grades`, {
        params: { sub_program_id: subProgramId }
      })
    },

    /**
     * Get teachers
     */
    getTeachers() {
      return httpClient.get(`${BASE_URL}/teachers`)
    },

    /**
     * Get buildings
     */
    getBuildings() {
      return httpClient.get(`${BASE_URL}/buildings`)
    },

    /**
     * Get rooms (optionally filtered by building ID)
     */
    getRooms(context, buildingId = null) {
      const params = buildingId ? { building_id: buildingId } : {}
      return httpClient.get(`${BASE_URL}/rooms`, { params })
    },

    /**
     * Get study times
     */
    getStudyTimes() {
      return httpClient.get(`${BASE_URL}/study-times`)
    },

    /**
     * Get class categories
     */
    getClassCategories() {
      return httpClient.get(`${BASE_URL}/class-categories`)
    },

    /**
     * Get academic years by status (for filter section)
     */
    getAcademicYears(context, academicStatusId) {
      return httpClient.get(`${BASE_URL}/academic-years`, {
        params: { academic_status_id: academicStatusId }
      })
    },

    /**
     * Get academic terms by year, status, and sub program (for filter section)
     */
    getAcademicTerms(context, { academicYearId, academicStatusId, subProgramId }) {
      return httpClient.get(`${BASE_URL}/academic-terms`, {
        params: {
          academic_year_id: academicYearId,
          academic_status_id: academicStatusId,
          sub_program_id: subProgramId
        }
      })
    },

    /**
     * Get academic years for row (current and next only)
     */
    getRowAcademicYears() {
      return httpClient.get(`${BASE_URL}/row-academic-years`)
    },

    /**
     * Get academic terms for row by year and sub program
     */
    getRowAcademicTerms(context, { academicYearId, subProgramId }) {
      return httpClient.get(`${BASE_URL}/row-academic-terms`, {
        params: {
          academic_year_id: academicYearId,
          sub_program_id: subProgramId
        }
      })
    },

    /**
     * Get classes for batch operation
     */
    getClasses(context, { mainProgramId, subProgramId, academicTermId }) {
      return httpClient.get(`${BASE_URL}/classes`, {
        params: {
          main_program_id: mainProgramId,
          sub_program_id: subProgramId,
          academic_term_id: academicTermId
        }
      })
    },

    /**
     * Create batch classes
     */
    createBatch(context, data) {
      return httpClient.post(`${BASE_URL}/batch`, data)
    }
  }
}
